<template>
  <div class="customer-wrap">

    <div class="house-tree" v-show="houseTreeVisable">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>

    <div class="body" :style="{width: houseTreeVisable? 'calc(100% - 260px)' : '100%'}">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="业户列表" name="ListMain">
          <ListMain v-if="card_index === 'ListMain'" />
        </el-tab-pane>
        <el-tab-pane label="业户综合列表" name="HouseCustomerList">
          <HouseCustomerList v-if="card_index === 'HouseCustomerList'" />
        </el-tab-pane>
        <el-tab-pane label="信息完整排序" name="CustomerCompletenessList">
          <CustomerCompletenessList v-if="card_index === 'CustomerCompletenessList'" />
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
  import ListMain from "./components/list/ListMain";
  import CustomerCompletenessList from "./components/list/CustomerCompletenessList";
  import HouseCustomerList from "./components/list/HouseCustomerList";
  export default {
    name: "CustomerList",
    provide() {
      return {
        mainObj: this.mainObj,
        toggleHouseTree: this.toggleHouseTree
      }
    },
    data(){
      return{
        houseTreeVisable: false,
        mainObj: {
          room_id: 0,
          organization_project_id: 0,
          room_name: '',
        },
        card_index: 'ListMain',
      }
    },
    components: {
      HouseCustomerList,
      CustomerCompletenessList,
      ListMain,
      'erp-tree-status': () => import('../Common/erp-tree-status.vue'),
    },
    methods: {
      nodeClick(data){
        if(data.tree[data.tree.length-1].type==='room'){
          this.mainObj.room_id = data.id
        }
        let room_name = []
        data.tree.forEach(item => {
          room_name.push(item.name)
        })
        this.mainObj.organization_project_id = data.tree[0].pindex_id;
        this.mainObj.room_name = room_name.join('->')
      },
      toggleHouseTree(){
        this.houseTreeVisable = !this.houseTreeVisable
      }
    },
    watch: {
      'mainObj.room_name'(val) {
        if(val == '') {
          this.mainObj.room_id = 0
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

.customer-wrap {
  padding: 20px;
  display: flex;
  position: relative;
  //width: calc(100% - 40px);

  .body {
    margin-left: 20px;
    width: calc(100% - 260px);
    height: calc(100vh - 120px);
    overflow: auto;

    //插入动画
    //transition: all 0.3s ease-in-out;
  }
  .house-tree{
    width: 250px;
    transition: all 0.3s ease-in-out;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/list.vue